import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import get from 'transmute/get';
import count from 'transmute/count';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import memoizeOne from 'react-utils/memoizeOne';
// HACK: we use this in lieu of a real field on options for storing rules
const DEPENDENT_OPTION_DESCRIPTION = /^Only show if (.*?) (is|contains) (.*)$/; // Allow non-53 portals to force dependent options filtering with `?dependentOptions=1`

const QUERY_PARAM_OVERRIDE = /(^|\?|&)dependentOptions=/;
export const isEnabled = () => {
  if (QUERY_PARAM_OVERRIDE.test(window.location.search)) {
    return true;
  }

  const BETPortalId = enviro.isQa() ? 99535353 : 53;

  if (BETPortalId === PortalIdParser.get()) {
    return true;
  }

  return false;
};
const isEnabledMemoized = memoizeOne(isEnabled);
/**
 * Returns only options which should be currently visible for an enum property,
 * based on dependency rules for each option and current draft property values.
 *
 * If an enum property option has a `description` matching the pattern:
 * "Only show if {property name} is {value}", the option will only appear
 * in the input if the current value of the property with the given name
 * matches the given value.
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!                               WARNING                                 !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * This is a prototype! It applies to portal 53 ONLY.
 *
 * The intent of this prototype is to iterate on UI behavior and logic
 * for dependent options. We are using 53 as a test case for eventual
 * productization of this feature. This should be behind a gate, however
 * customer-data-properties does not have easy access to gates info.
 *
 * Because property definitions have no place today to store dependency
 * rules, we are temporarily using (in portal 53 only, and for the purposes of
 * this prototype only) `property.option.description` as the place to store
 * this metadata. This field is not surfaced in the UI, either in property
 * settings or in the CRM, but we use a "human-readable-ish" string for
 * defining the rules just in case it does get surfaced in the future.
 *
 * After we decide how flexible dependency rules need to be, this metadata
 * will need to be moved to a field on the option definition, and the logic
 * here will need to be updated to respect those rules.
 */

export const filterDependentOptionsInternal = (options, getAdditionalPropertyValue, objectId, objectTypeId) => {
  const filtered = options && options.filter(option => {
    const description = get('description', option);
    const match = description && description.match(DEPENDENT_OPTION_DESCRIPTION);

    if (match) {
      const [__, dependentProperty, operator, dependentValue] = match;
      const secondaryPropertyValue = getAdditionalPropertyValue(dependentProperty, objectId, objectTypeId);

      switch (operator) {
        case 'is':
          {
            // a description of 'Only show if <propertyName> is <value>' means this option should
            // only appear if the value of the property with the given name equals the given value
            return `${secondaryPropertyValue}` === dependentValue;
          }

        case 'contains':
          {
            // a description of 'Only show if <propertyName> contains <value>' means this option should
            // only appear if the value of the property with the given name includes the given value
            // (semicolon-delimited)
            return parseMultiEnumValue(secondaryPropertyValue).includes(dependentValue);
          }

        default:
          // Unknown operator
          break;
      }
    }

    return true;
  });
  return options && filtered && count(options) === count(filtered) ? options : filtered;
};
export const filterDependentOptions = (options, getAdditionalPropertyValue, objectId, objectTypeId) => {
  if (!isEnabledMemoized()) {
    return options;
  }

  return filterDependentOptionsInternal(options, getAdditionalPropertyValue, objectId, objectTypeId);
};